import { Button, Dropdown, ListGroup, DropdownButton } from 'react-bootstrap';
import languageIcon from '@/public/images/icons/dashboard/language.svg';
import { MenuLanguageItemProps } from '@/types/props/components';
import Image from 'next/image';
import { useCallback, useState } from 'react';
import stylesConstants from '@/constants/styles.constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import languageConstants from '@/constants/language.constants';
import translationfallbackTyped from '@/utilites/translations/translationfallbackTyped';
import clsx from 'clsx';
import { getValidLocale } from '@/utilites/language/language.utils';
import handleLanguageChange from '@/utilites/handle-language-change';
export default function MenuLanguageItem({
  mainText,
  locale,
  tHeader,
  tCommon,
  router,
  userExist,
  queryClient,
}: MenuLanguageItemProps) {
  const handleLanguageSwitch = useCallback(
    async (language: string) => {
      return await handleLanguageChange(
        language,
        tCommon,
        router,
        userExist,
        queryClient
      );
    },
    [tCommon, router, userExist, queryClient]
  );

  const defaultListItemClass = stylesConstants.header.menuLinks.defaultLiClass;
  const mainSectionClass = stylesConstants.header.menuLinks.mainSectionClass;
  const liLanguageClass = stylesConstants.header.menuLinks.liLanguageClass;
  const listItemActiveClass = stylesConstants.header.menuLinks.liClassActive;
  const listItemInactiveClass =
    stylesConstants.header.menuLinks.liClassInactive;

  const [show, setShow] = useState(false);

  const toggleDropdown = () => {
    setShow((prev) => !prev);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setShow(!show);
    }
  };

  const validLocale = getValidLocale(locale);

  return (
    <Dropdown show={show}>
      <ListGroup.Item
        as={Dropdown.Toggle}
        variant=""
        onClick={toggleDropdown}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onKeyDown={handleKeyDown}
        className={clsx(
          `${defaultListItemClass} tw-relative tw-w-full after:!tw-hidden`,
          {
            [`${listItemActiveClass}`]: show,
            [`${listItemInactiveClass}`]: !show,
          }
        )}
      >
        <div className={mainSectionClass}>
          <Image
            src={languageIcon}
            width={24}
            height={24}
            alt={mainText}
            className="me-2"
          />
          <span className="limit-2-lines">{mainText}</span>
        </div>
        <FontAwesomeIcon icon={faChevronRight} className="m-0" />
        <Dropdown.Menu className="!tw-absolute !tw-left-full !tw-top-0 !tw-transform-none">
          {languageConstants.localesWithIconsArray.map((locale, index) => (
            <Dropdown.Item
              onClick={() => handleLanguageSwitch(locale.locale)}
              key={`language-${index}`}
              className={clsx(liLanguageClass, {
                [`${listItemActiveClass}`]: locale.locale === validLocale,
                [`${listItemInactiveClass}`]: locale.locale !== validLocale,
              })}
            >
              <Image
                src={locale.icon}
                width={24}
                height={24}
                alt={translationfallbackTyped(
                  locale.tHeaderKey,
                  tHeader,
                  locale.tFallback
                )}
              />
              {translationfallbackTyped(
                locale.tHeaderKey,
                tHeader,
                locale.tFallback
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </ListGroup.Item>
    </Dropdown>
  );
}
